export default __webpack_public_path__ + "static/media/a29ca99201ff76dbcd5908f5bbeb890b.svg";